module.exports = __webpack_public_path__ + "static/media/click.ce296b95.mp3";